module.exports = __webpack_public_path__ + "img/sp-1.5f414c27.png";